<template>
  <v-row justify="center">
    <v-dialog v-model="shower" scrollable max-width="1200px" persistent>
      <v-card class="rounded-lg">
        <v-card-title>
          รายการขอคำร้อง
          <v-spacer></v-spacer>
          <v-layout row wrap align-center justify-end>
            <v-flex xs2 lg2>
              <v-btn color="error" block dark outlined @click="fn_close()">
                {{ $t("consentform.close") }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pl-10 pr-10 pt-6 grey--text">
          <template>
            <v-data-table
              :headers="headers"
              :items="_detail"
              hide-default-footer
            >
              <template v-slot:[`item.CancelId`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      color="#077893"
                      style="cursor: pointer"
                      small
                      @click="Fn_CopyDetail(item.CancelId)"
                      v-on="on"
                      >mdi-file-multiple-outline</v-icon
                    >
                  </template>
                  <span>{{ $t("consentlist.copy") }}</span>
                </v-tooltip>
                {{ item.CancelId }}
              </template>
              <template v-slot:[`item.Status`]="{ item }">
                <v-chip v-if="item.Status == 'OK'" color="#388E3C" dark>
                  {{ $t("onechat.status4") }}
                </v-chip>
                <v-chip v-if="item.Status == 'ER'" color="#B71C1C" dark>
                  {{ $t("onechat.status3") }}
                </v-chip>
                <v-chip v-if="item.Status == 'pending'" color="warning" dark>
                  รอตอบกลับ
                </v-chip>
              </template>
              <template v-slot:[`item.ErrorMessage`]="{ item }">
                <div v-if="item.ErrorMessage == null">-</div>
                <div v-else>
                  {{ item.ErrorMessage }}
                </div>
              </template>
            </v-data-table>
          </template>
        </v-card-text>
        <br />
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: ["show", "_detail"],
  data: function () {
    return {
      headers: [
        {
          text: "รหัสเลขคำร้อง",
          align: "start",
          value: "CancelId",
          sortable: false,
        },
        {
          text: "หัวข้อคำร้อง",
          value: "SubjectRequest",
          sortable: false,
          align: "center",
        },
        { text: "ชื่อ", value: "NameTh", sortable: false, align: "center" },
        {
          text: "ประเภทคำร้อง",
          value: "SourceSystem",
          sortable: false,
          align: "center",
        },
        {
          text: "ข้อความ",
          value: "ErrorMessage",
          sortable: false,
          align: "center",
        },
        { text: "สถานะ", value: "Status", sortable: false, align: "center" },
      ],
    };
  },
  created() {},
  computed: {
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialog");
        }
      },
    },
  },
  watch: {},
  methods: {
    fn_close() {
      this.$emit("closeDialog");
      // window.location.reload();
    },
    async Fn_CopyDetail(val) {
      await navigator.clipboard.writeText(val);
    },
  },
};
</script>
